export { TrendingDown as default } from './TrendingDown';
